const namespace = "verseImaEvent";

export const AD_LOADED = `${namespace}.AD_LOADED`;
export const AD_COMPLETE = `${namespace}.AD_COMPLETE`;
export const AD_DURATION_CHANGE = `${namespace}.AD_DURATION_CHANGE`;
export const AD_IS_SKIP_ALLOWED_NOW_CHANGE = `${namespace}.AD_IS_SKIP_ALLOWED_NOW_CHANGE`;
export const AD_IS_SKIPPABLE_CHANGE = `${namespace}.AD_IS_SKIPPABLE_CHANGE`;
export const AD_NOT_PLAYING = `${namespace}.AD_NOT_PLAYING`;
export const AD_PLAYING = `${namespace}.AD_PLAYING`;
export const AD_PAUSED = `${namespace}.AD_PAUSED`;
export const AD_RESUMED = `${namespace}.AD_RESUMED`;
export const AD_TIME_UPDATE = `${namespace}.AD_TIME_UPDATE`;
export const USER_REQUESTED_SKIP = `${namespace}.USER_REQUESTED_SKIP`;
